module.exports = __webpack_public_path__ + "img/RORBPJR40022.fdffce1c.png";